import red from "@material-ui/core/colors/red";
import { createMuiTheme } from "@material-ui/core/styles";
import BuenosAiresWeb_Regular from "./fonts/BuenosAiresWeb-Regular";
import BuenosAiresWeb_RegularItalic from "./fonts/BuenosAiresWeb-RegularItalic";
import BuenosAiresWeb_Bold from "./fonts/BuenosAiresWeb-Bold";
import BuenosAiresWeb_BoldItalic from "./fonts/BuenosAiresWeb-BoldItalic";
import BuenosAiresWeb_Light from "./fonts/BuenosAiresWeb-Light";
import BuenosAiresWeb_LightItalic from "./fonts/BuenosAiresWeb-LightItalic";
import BuenosAiresWeb_Thin from "./fonts/BuenosAiresWeb-Thin";
import BuenosAiresWeb_ThinItalic from "./fonts/BuenosAiresWeb-ThinItalic";

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#00224D",
    },
    secondary: {
      main: "#97B3CD",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#fff",
    },
    success: {
      main: "#4caf50",
    },
  },
  typography: {
    fontFamily: ["BuenosAiresWeb", "Roboto", "Helvetica", "Arial", "sans-serif"].join(","),
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": [
          BuenosAiresWeb_Regular,
          BuenosAiresWeb_RegularItalic,
          BuenosAiresWeb_Bold,
          BuenosAiresWeb_BoldItalic,
          BuenosAiresWeb_Light,
          BuenosAiresWeb_LightItalic,
          BuenosAiresWeb_Thin,
          BuenosAiresWeb_ThinItalic,
        ],
        ".MuiButton-label": {
          textWrap: "nowrap",
        },
      },
    },
  },
});

export default theme;
